(function () {
  'use strict';

  var COMPANY_CACHE_KEY = 'wom_overall_company_conscious_chemist_v1';
  var REVIEWS_CACHE_PREFIX = 'wom_activity_reviews_';
  var VISIBLE_MS = 3500;
  var INTERVAL_MS = 5500;
  var FIRST_DELAY_MS = 2500;
  var TTL = 600000;

  var API_COMPANY = 'https://api.thewordofmouth.in/api/overall_company/conscious_chemist';
  var API_REVIEWS = 'https://api.thewordofmouth.in/api/reviews/conscious_chemist/';

  var PERF = window.WOMPerf || { mark: function () { }, span: function () { return function () { }; } };
  var PAGE_DISMISS_FLAG = '__WOM_ACTIVITY_BANNER_DISMISSED__';
  var DISMISS_STORAGE_KEY = 'wom_activity_banner_dismissed';
  var STAR_COLOR = '#FDB022';
  var EMPTY_STAR_COLOR = '#E5E7EB';
  var STAR_PATH =
    'M10 15l-5.878 3.09 1.123-6.545L.489 6.91l6.572-.955L10 0l2.939 5.955 6.572.955-4.756 4.635 1.123 6.545z';

  /* Client 10-day landing page performance (real store data) */
  var STORE_STATS = {
    period_days: 10,
    add_to_cart: 121368,
    orders: 23169,
    sessions: 543608,
    visitors: 530232,
  };

  function parseJsonAttr(root, attr, fallback) {
    try {
      var raw = root.getAttribute(attr) || '';
      if (!raw) return fallback;
      return JSON.parse(raw);
    } catch (e) {
      return fallback;
    }
  }

  function readCache(key) {
    try {
      var raw = sessionStorage.getItem(key);
      if (!raw) return null;
      var parsed = JSON.parse(raw);
      if (!parsed || !parsed.t) return null;
      if (Date.now() - parsed.t > TTL) return null;
      return parsed.data;
    } catch (e) {
      return null;
    }
  }

  function writeCache(key, data) {
    try {
      sessionStorage.setItem(key, JSON.stringify({ t: Date.now(), data: data }));
    } catch (e) {}
  }

  function isPageReload() {
    try {
      var nav = performance.getEntriesByType && performance.getEntriesByType('navigation')[0];
      if (nav && nav.type) return nav.type === 'reload';
    } catch (e) {}
    try {
      return performance.navigation && performance.navigation.type === 1;
    } catch (e2) {}
    return false;
  }

  function syncDismissState() {
    try {
      if (isPageReload()) {
        sessionStorage.removeItem(DISMISS_STORAGE_KEY);
        window[PAGE_DISMISS_FLAG] = false;
        return;
      }
      window[PAGE_DISMISS_FLAG] = sessionStorage.getItem(DISMISS_STORAGE_KEY) === '1';
    } catch (e) {
      window[PAGE_DISMISS_FLAG] = !!window[PAGE_DISMISS_FLAG];
    }
  }

  function persistBannerDismiss() {
    window[PAGE_DISMISS_FLAG] = true;
    try {
      sessionStorage.setItem(DISMISS_STORAGE_KEY, '1');
    } catch (e) {}
  }

  syncDismissState();

  function lookupHandle(data, handle) {
    if (!data || !handle) return null;
    var keys = [handle, handle.replace(/-/g, '_'), handle.replace(/_/g, '-')];
    for (var i = 0; i < keys.length; i++) {
      if (data[keys[i]]) return data[keys[i]];
    }
    return null;
  }

  function parseReviewInstant(value) {
    if (value == null || value === '') return new Date();
    var s = String(value).trim();

    if (/^\d{4}-\d{2}-\d{2}$/.test(s)) {
      var parts = s.split('-').map(Number);
      var dayStart = new Date(parts[0], parts[1] - 1, parts[2], 0, 0, 0, 0);
      var todayStart = new Date();
      todayStart.setHours(0, 0, 0, 0);
      if (dayStart.getTime() === todayStart.getTime()) return new Date();
      return dayStart;
    }

    var monthMatch = s.match(/^([A-Za-z]{3,9})\s+(\d{1,2}),\s+(\d{4})$/);
    if (monthMatch) {
      var months = {
        Jan: 0, January: 0,
        Feb: 1, February: 1,
        Mar: 2, March: 2,
        Apr: 3, April: 3,
        May: 4,
        Jun: 5, June: 5,
        Jul: 6, July: 6,
        Aug: 7, August: 7,
        Sep: 8, Sept: 8, September: 8,
        Oct: 9, October: 9,
        Nov: 10, November: 10,
        Dec: 11, December: 11,
      };
      var mo = months[monthMatch[1]];
      if (mo != null) {
        return new Date(Number(monthMatch[3]), mo, Number(monthMatch[2]), 12, 0, 0, 0);
      }
    }

    var parsed = new Date(s);
    return isNaN(parsed.getTime()) ? new Date() : parsed;
  }

  function startOfDay(date) {
    var d = new Date(date);
    d.setHours(0, 0, 0, 0);
    return d;
  }

  function getTimeAgo(value) {
    try {
      var date = parseReviewInstant(value);
      var now = new Date();
      var dayDiff = Math.floor((startOfDay(now) - startOfDay(date)) / 86400000);

      if (dayDiff === 0) {
        var seconds = Math.floor((now - date) / 1000);
        if (seconds < 0) seconds = 0;
        if (seconds < 60) return 'just now';
        if (seconds < 3600) {
          var minutes = Math.floor(seconds / 60);
          return minutes + ' minute' + (minutes > 1 ? 's' : '') + ' ago';
        }
        var hours = Math.floor(seconds / 3600);
        return hours + ' hour' + (hours > 1 ? 's' : '') + ' ago';
      }
      if (dayDiff === 1) return 'yesterday';
      if (dayDiff < 7) return dayDiff + ' days ago';
      if (dayDiff < 30) {
        var weeks = Math.floor(dayDiff / 7);
        return weeks + ' week' + (weeks > 1 ? 's' : '') + ' ago';
      }
      if (dayDiff < 365) {
        var months = Math.floor(dayDiff / 30);
        return months + ' month' + (months > 1 ? 's' : '') + ' ago';
      }
      var years = Math.floor(dayDiff / 365);
      return years + ' year' + (years > 1 ? 's' : '') + ' ago';
    } catch (e) {
      return String(value || '');
    }
  }

  function getReviewActivityLabel(value) {
    var date = parseReviewInstant(value);
    var now = new Date();
    var seconds = Math.max(0, Math.floor((now - date) / 1000));
    var dayDiff = Math.floor((startOfDay(now) - startOfDay(date)) / 86400000);
    var action = 'reviewed';

    if (seconds < 3600) {
      action = 'just reviewed';
    } else if (dayDiff === 0) {
      action = 'reviewed today';
    }

    return {
      action: action,
      time: getTimeAgo(value),
    };
  }

  function formatIndianNumber(num) {
    var n = Math.max(0, Math.round(Number(num) || 0));
    return n.toLocaleString('en-IN');
  }

  function shortName(fullName) {
    if (!fullName) return '';
    var parts = String(fullName).trim().split(/\s+/);
    if (parts.length === 1) return parts[0];
    return parts[0] + ' ' + parts[parts.length - 1].charAt(0) + '.';
  }

  function truncate(text, max) {
    if (!text) return '';
    var s = String(text).trim();
    if (s.length <= max) return s;
    return s.slice(0, max).trim() + '…';
  }

  function clampRating(value) {
    return Math.max(0, Math.min(5, Math.round(Number(value) || 0)));
  }

  function getReviewImages(review) {
    if (!review || !Array.isArray(review.images)) return [];
    return review.images
      .map(function (img) {
        if (typeof img === 'string') return img;
        return (img && (img.s3_url || img.url)) || '';
      })
      .filter(Boolean);
  }

  function reviewTimestamp(review) {
    return parseReviewInstant(review && (review.date || review.createdAt)).getTime();
  }

  function sortReviewsLatest(reviews) {
    return reviews.slice().sort(function (a, b) {
      return reviewTimestamp(b) - reviewTimestamp(a);
    });
  }

  function renderStarsHTML(rating, sizeClass) {
    var stars = clampRating(rating);
    if (!stars) return '';
    var html = '';
    for (var i = 1; i <= 5; i++) {
      var fill = i <= stars ? STAR_COLOR : EMPTY_STAR_COLOR;
      html +=
        '<svg viewBox="0 0 20 20" aria-hidden="true"' +
        (sizeClass ? ' class="' + sizeClass + '"' : '') +
        '><path fill="' +
        fill +
        '" d="' +
        STAR_PATH +
        '"/></svg>';
    }
    return html;
  }

  function closeReviewModal() {
    var existing = document.querySelector('[data-wab-review-modal]');
    if (existing) existing.remove();
    document.body.classList.remove('wab-modal-open');
    document.body.style.overflow = '';
  }

  function openReviewModal(item) {
    if (!item || !item.reviewData) return;
    closeReviewModal();

    var review = item.reviewData;
    var rating = clampRating(review.rating);

    var overlay = document.createElement('div');
    overlay.className = 'wab-modal';
    overlay.setAttribute('data-wab-review-modal', 'true');
    overlay.setAttribute('role', 'dialog');
    overlay.setAttribute('aria-modal', 'true');
    overlay.setAttribute('aria-label', 'Customer review');

    var panel = document.createElement('div');
    panel.className = 'wab-modal__panel';

    var closeBtn = document.createElement('button');
    closeBtn.type = 'button';
    closeBtn.className = 'wab-modal__close';
    closeBtn.setAttribute('aria-label', 'Close review');
    closeBtn.innerHTML =
      '<svg viewBox="0 0 24 24" width="16" height="16" fill="none" aria-hidden="true"><path d="M6 6l12 12M18 6L6 18" stroke="currentColor" stroke-width="1.75" stroke-linecap="round"/></svg>';
    closeBtn.addEventListener('click', function (e) {
      e.preventDefault();
      closeReviewModal();
    });

    if (item.modalImage || item.image) {
      var hero = document.createElement('img');
      hero.className = 'wab-modal__hero';
      hero.src = item.modalImage || item.image;
      hero.alt = item.hasReviewImage ? 'Customer review photo' : item.title || 'Product';
      hero.decoding = 'async';
      panel.appendChild(hero);
    }

    var body = document.createElement('div');
    body.className = 'wab-modal__body';

    if (item.title) {
      var productEl = document.createElement('p');
      productEl.className = 'wab-modal__product';
      productEl.textContent = item.title;
      body.appendChild(productEl);
    }

    var header = document.createElement('div');
    header.className = 'wab-modal__header';

    var identity = document.createElement('div');
    var nameEl = document.createElement('p');
    nameEl.className = 'wab-modal__name';
    nameEl.textContent = review.user_name || item.name || 'Customer';
    identity.appendChild(nameEl);

    var metaParts = [];
    if (review.location || item.city) metaParts.push(review.location || item.city);
    if (item.time) metaParts.push(item.time);
    if (metaParts.length) {
      var metaEl = document.createElement('p');
      metaEl.className = 'wab-modal__meta';
      metaEl.textContent = metaParts.join(' · ');
      identity.appendChild(metaEl);
    }

    header.appendChild(identity);

    if (rating) {
      var starsWrap = document.createElement('span');
      starsWrap.className = 'wab-modal__stars';
      starsWrap.innerHTML = renderStarsHTML(rating);
      starsWrap.setAttribute('aria-label', rating + ' out of 5 stars');
      header.appendChild(starsWrap);
    }

    body.appendChild(header);

    if (review.title) {
      var titleEl = document.createElement('p');
      titleEl.className = 'wab-modal__title';
      titleEl.textContent = review.title;
      body.appendChild(titleEl);
    }

    if (review.review_text) {
      var textEl = document.createElement('p');
      textEl.className = 'wab-modal__text';
      textEl.textContent = review.review_text;
      body.appendChild(textEl);
    }

    var footer = document.createElement('div');
    footer.className = 'wab-modal__footer';

    var dateEl = document.createElement('span');
    dateEl.textContent = review.date || '';
    footer.appendChild(dateEl);

    if (review.verified_batch) {
      var verified = document.createElement('span');
      verified.className = 'wab-modal__verified';
      verified.textContent = 'Verified purchase';
      footer.appendChild(verified);
    }

    body.appendChild(footer);
    panel.appendChild(closeBtn);
    panel.appendChild(body);
    overlay.appendChild(panel);

    overlay.addEventListener('click', function (e) {
      if (e.target === overlay) closeReviewModal();
    });

    document.body.appendChild(overlay);
    document.body.classList.add('wab-modal-open');
    document.body.style.overflow = 'hidden';
    closeBtn.focus();

    document.addEventListener(
      'keydown',
      function onKey(e) {
        if (e.key === 'Escape') {
          closeReviewModal();
          document.removeEventListener('keydown', onKey);
        }
      },
      { once: true }
    );
  }

  function fetchCompanyData() {
    var cached = readCache(COMPANY_CACHE_KEY);
    if (cached) {
      return Promise.resolve(cached);
    }

    return fetch(API_COMPANY, { credentials: 'omit' })
      .then(function (r) {
        return r.ok ? r.json() : null;
      })
      .then(function (json) {
        if (json && typeof json === 'object') {
          writeCache(COMPANY_CACHE_KEY, json);
          return json;
        }
        return null;
      })
      .catch(function () {
        return null;
      });
  }

  function fetchProductReviews(handle) {
    if (!handle) return Promise.resolve(null);
    var cacheKey = REVIEWS_CACHE_PREFIX + handle;
    var cached = readCache(cacheKey);
    if (cached) return Promise.resolve(cached);

    return fetch(API_REVIEWS + encodeURIComponent(handle), { credentials: 'omit' })
      .then(function (r) {
        return r.ok ? r.json() : null;
      })
      .then(function (json) {
        if (json && Array.isArray(json.reviews)) {
          writeCache(cacheKey, json);
          return json;
        }
        return null;
      })
      .catch(function () {
        return null;
      });
  }

  function catalogByHandle(catalog) {
    var map = {};
    (catalog || []).forEach(function (item) {
      if (item && item.handle) map[item.handle] = item;
    });
    return map;
  }

  function totalReviewCount(companyData) {
    if (!companyData) return 0;
    return Object.keys(companyData).reduce(function (sum, key) {
      return sum + (Number(companyData[key].total_reviews) || 0);
    }, 0);
  }

  function productShare(handle, companyData) {
    var total = totalReviewCount(companyData);
    if (total <= 0) return 0;
    var row = lookupHandle(companyData, handle);
    return (Number(row && row.total_reviews) || 0) / total;
  }

  function productViewShare(handle, companyData) {
    var share = productShare(handle, companyData);
    if (share > 0) return share;
    if (!companyData) return 0;
    var keys = Object.keys(companyData);
    return keys.length ? 1 / keys.length : 0;
  }

  function buildStatItems(pageType, productHandle, companyData, catalogMap) {
    var items = [];
    var days = STORE_STATS.period_days;

    if (pageType === 'product' && productHandle) {
      var productMeta = metaForHandle(productHandle, catalogMap);
      var share = productShare(productHandle, companyData);
      var viewShare = productViewShare(productHandle, companyData);
      var productViews = Math.max(1, Math.round(STORE_STATS.visitors * viewShare));
      var productATC = Math.max(1, Math.round(STORE_STATS.add_to_cart * share));
      var productOrders = Math.max(1, Math.round(STORE_STATS.orders * share));

      if (viewShare > 0) {
        items.push({
          type: 'stat',
          message:
            formatIndianNumber(productViews) +
            ' people viewed this product in the last ' +
            days +
            ' days',
          url: productMeta.url || '#',
          image: productMeta.image || '',
          title: productMeta.title || '',
        });
      }

      if (share > 0) {
        items.push({
          type: 'stat',
          message:
            formatIndianNumber(productATC) +
            ' people added this to cart in the last ' +
            days +
            ' days',
          url: productMeta.url || '#',
          image: productMeta.image || '',
          title: productMeta.title || '',
        });

        items.push({
          type: 'stat',
          message:
            formatIndianNumber(productOrders) +
            ' people bought this in the last ' +
            days +
            ' days',
          url: productMeta.url || '#',
          image: productMeta.image || '',
          title: productMeta.title || '',
        });
      }
    } else {
      items.push({
        type: 'stat',
        message:
          formatIndianNumber(STORE_STATS.visitors) +
          ' people viewed Conscious Chemist in the last ' +
          days +
          ' days',
        url: '/collections/all',
      });

      items.push({
        type: 'stat',
        message:
          formatIndianNumber(STORE_STATS.add_to_cart) +
          ' people added products to cart in the last ' +
          days +
          ' days',
        url: '/collections/all',
      });

      items.push({
        type: 'stat',
        message:
          formatIndianNumber(STORE_STATS.orders) +
          ' people bought from Conscious Chemist in the last ' +
          days +
          ' days',
        url: '/collections/all',
      });
    }

    return items;
  }

  function metaForHandle(handle, catalogMap) {
    if (catalogMap[handle]) return catalogMap[handle];
    return {
      handle: handle,
      title: handle
        ? handle.replace(/-/g, ' ').replace(/\b\w/g, function (c) {
            return c.toUpperCase();
          })
        : 'this product',
      url: handle ? '/products/' + handle : '#',
      image: '',
      image_large: '',
    };
  }

  function buildReviewItems(reviewsPayload, catalogMap, handle) {
    var meta = metaForHandle(handle, catalogMap);
    var reviews = sortReviewsLatest((reviewsPayload && reviewsPayload.reviews) || []);
    var withImages = reviews.filter(function (review) {
      return getReviewImages(review).length > 0;
    });
    var pool = withImages.length ? withImages : reviews;
    var items = [];

    pool.slice(0, 8).forEach(function (review) {
      if (!review || !review.user_name) return;
      var rating = clampRating(review.rating);
      var reviewImages = getReviewImages(review);
      var reviewImage = reviewImages[0] || '';
      var productThumb = meta.image || '';
      var productLarge = meta.image_large || meta.image || '';

      var activity = getReviewActivityLabel(review.date || review.createdAt);

      items.push({
        type: 'review',
        name: shortName(review.user_name),
        city: review.location || '',
        action: activity.action,
        rating: rating,
        title: meta.title || truncate(review.review_text, 42) || 'this product',
        time: activity.time,
        url: meta.url || '#',
        image: reviewImage || productThumb,
        modalImage: reviewImage || productLarge,
        hasReviewImage: !!reviewImage,
        reviewData: review,
        sortTime: reviewTimestamp(review),
      });
    });

    return items;
  }

  function interleaveItems(reviewItems, statItems) {
    var merged = [];
    var r = 0;
    var s = 0;
    var total = reviewItems.length + statItems.length;

    while (merged.length < total) {
      if (r < reviewItems.length) {
        merged.push(reviewItems[r]);
        r += 1;
      }
      if (s < statItems.length && merged.length < total) {
        merged.push(statItems[s]);
        s += 1;
      }
      if (r >= reviewItems.length && s >= statItems.length) break;
    }

    return merged;
  }

  function applyItem(root, item) {
    if (!item) return;

    var customerRow = root.querySelector('[data-wab-customer-row]');
    var detailRow = root.querySelector('[data-wab-detail-row]');
    var statEl = root.querySelector('[data-wab-stat]');
    var nameEl = root.querySelector('[data-wab-name]');
    var cityEl = root.querySelector('[data-wab-city]');
    var actionEl = root.querySelector('[data-wab-action]');
    var productEl = root.querySelector('[data-wab-product]');
    var timeEl = root.querySelector('[data-wab-time]');
    var linkEl = root.querySelector('[data-wab-link]');
    var thumbWrap = root.querySelector('[data-wab-thumb-wrap]');
    var thumb = root.querySelector('[data-wab-thumb]');
    var starsEl = root.querySelector('[data-wab-stars]');

    root._wabCurrentItem = item;

    root.classList.toggle('wab--stat', item.type === 'stat');
    root.classList.toggle('wab--review', item.type === 'review');

    if (linkEl) {
      linkEl.setAttribute(
        'aria-label',
        item.type === 'review' ? 'Open customer review' : 'View details'
      );
    }

    if (item.type === 'stat') {
      if (customerRow) customerRow.hidden = true;
      if (detailRow) detailRow.hidden = true;
      if (starsEl) {
        starsEl.innerHTML = '';
        starsEl.hidden = true;
      }
      if (statEl) {
        statEl.hidden = false;
        statEl.textContent = item.message || '';
      }
    } else {
      if (customerRow) customerRow.hidden = false;
      if (detailRow) detailRow.hidden = false;
      if (statEl) statEl.hidden = true;
      if (nameEl) nameEl.textContent = item.name || '';
      if (cityEl) cityEl.textContent = item.city || '';
      if (actionEl) actionEl.textContent = item.action || 'reviewed';
      if (productEl) productEl.textContent = item.title || '';
      if (timeEl) timeEl.textContent = item.time || '';

      if (starsEl) {
        if (item.rating) {
          starsEl.innerHTML = renderStarsHTML(item.rating);
          starsEl.hidden = false;
          starsEl.setAttribute('aria-label', item.rating + ' out of 5 stars');
        } else {
          starsEl.innerHTML = '';
          starsEl.hidden = true;
          starsEl.removeAttribute('aria-label');
        }
      }
    }

    if (thumbWrap && thumb) {
      if (item.image) {
        thumb.alt = item.title || '';
        setThumbImage(root, item, thumb, thumbWrap);
      } else {
        thumb.removeAttribute('src');
        thumb.hidden = true;
        thumbWrap.hidden = item.type === 'stat';
      }
    }
  }

  var wabImageCache = {};
  var wabImagePending = {};

  function preloadWabImage(url) {
    if (!url) return Promise.resolve(false);
    if (wabImageCache[url] === true) return Promise.resolve(true);
    if (wabImageCache[url] === false) return Promise.resolve(false);
    if (wabImagePending[url]) return wabImagePending[url];

    wabImagePending[url] = new Promise(function (resolve) {
      var img = new Image();
      img.decoding = 'async';
      img.onload = function () {
        wabImageCache[url] = true;
        delete wabImagePending[url];
        resolve(true);
      };
      img.onerror = function () {
        wabImageCache[url] = false;
        delete wabImagePending[url];
        resolve(false);
      };
      img.src = url;
    });

    return wabImagePending[url];
  }

  function preloadWabImagesSequential(list, start, count) {
    var chain = Promise.resolve();
    var end = Math.min(list.length, start + count);
    for (var i = start; i < end; i++) {
      (function (item) {
        if (!item || !item.image) return;
        chain = chain.then(function () {
          return preloadWabImage(item.image);
        });
      })(list[i]);
    }
    return chain;
  }

  function warmNextWabImage(list, fromIndex) {
    if (!list || !list.length) return;
    var next = list[fromIndex % list.length];
    if (next && next.image) preloadWabImage(next.image);
  }

  function setThumbImage(root, item, thumb, thumbWrap) {
    if (!item || !item.image || !thumb || !thumbWrap) return;

    function reveal() {
      if (root._wabCurrentItem !== item) return;
      thumb.src = item.image;
      thumb.hidden = false;
      thumbWrap.hidden = false;
    }

    if (wabImageCache[item.image] === true) {
      reveal();
      return;
    }

    thumb.hidden = true;
    thumbWrap.hidden = false;
    preloadWabImage(item.image).then(function (ok) {
      if (ok) reveal();
      else {
        thumb.removeAttribute('src');
        thumb.hidden = true;
        thumbWrap.hidden = item.type === 'stat';
      }
    });
  }

  function mergeReviewItems(existing, incoming) {
    var merged = (existing || []).slice();
    var seen = {};
    merged.forEach(function (item) {
      if (item && item.reviewData) {
        seen[String(item.reviewData.id || item.sortTime || item.name)] = true;
      }
    });
    (incoming || []).forEach(function (item) {
      if (!item) return;
      var key = item.reviewData
        ? String(item.reviewData.id || item.sortTime || item.name)
        : String(item.message || item.title || Math.random());
      if (seen[key]) return;
      seen[key] = true;
      merged.push(item);
    });
    merged.sort(function (a, b) {
      if (a.hasReviewImage !== b.hasReviewImage) {
        return a.hasReviewImage ? -1 : 1;
      }
      return (b.sortTime || 0) - (a.sortTime || 0);
    });
    return merged;
  }

  function sortReviewItems(reviewItems) {
    return reviewItems.slice().sort(function (a, b) {
      if (a.hasReviewImage !== b.hasReviewImage) {
        return a.hasReviewImage ? -1 : 1;
      }
      return (b.sortTime || 0) - (a.sortTime || 0);
    });
  }

  function loadItems(root, onItemsUpdate) {
    var pageType = root.getAttribute('data-wab-page-type') || 'index';
    var productHandle = root.getAttribute('data-wab-product-handle') || '';
    var catalog = parseJsonAttr(root, 'data-wab-catalog', []);
    var catalogMap = catalogByHandle(catalog);

    var handles = catalog.map(function (item) {
      return item && item.handle;
    }).filter(Boolean);

    if (!handles.length && productHandle) handles = [productHandle];

    return fetchCompanyData().then(function (companyData) {
      if (!handles.length && companyData) {
        handles = Object.keys(companyData)
          .filter(function (key) {
            return Number(companyData[key].total_reviews) > 0;
          })
          .sort(function (a, b) {
            return (Number(companyData[b].total_reviews) || 0) - (Number(companyData[a].total_reviews) || 0);
          })
          .slice(0, 4);
      }

      if (!handles.length) {
        return [];
      }

      var fetchHandles = handles.slice(0, 4);
      if (pageType === 'product' && productHandle) {
        fetchHandles = [productHandle];
      }

      function fetchReviewGroup(handle) {
        return fetchProductReviews(handle).then(function (payload) {
          return buildReviewItems(payload, catalogMap, handle);
        });
      }

      return fetchReviewGroup(fetchHandles[0]).then(function (firstGroup) {
        var reviewItems = sortReviewItems(firstGroup);

        if (fetchHandles.length > 1) {
          var rest = fetchHandles.slice(1);
          var chain = Promise.resolve();
          rest.forEach(function (handle) {
            chain = chain.then(function () {
              return fetchReviewGroup(handle).then(function (group) {
                reviewItems = mergeReviewItems(reviewItems, group);
                if (typeof onItemsUpdate === 'function') onItemsUpdate(reviewItems);
                return group;
              });
            });
          });
          chain.catch(function () {});
        }

        return reviewItems;
      });
    });
  }

  function initBanner(root) {
    if (!root || root.getAttribute('data-wab-init') === '1') return;
    root.setAttribute('data-wab-init', '1');

    if (window[PAGE_DISMISS_FLAG]) {
      root.hidden = true;
      root.classList.remove('is-visible', 'is-hiding');
      return;
    }

    var closeBtn = root.querySelector('[data-wab-close]');
    var items = [];
    var idx = 0;
    var hideTimer = null;
    var cycleTimer = null;
    var stopped = false;

    function clearTimers() {
      if (hideTimer) window.clearTimeout(hideTimer);
      if (cycleTimer) window.clearTimeout(cycleTimer);
      hideTimer = null;
      cycleTimer = null;
    }

    function hideBanner(permanent) {
      root.classList.remove('is-visible');
      root.classList.add('is-hiding');
      window.setTimeout(function () {
        root.classList.remove('is-hiding');
        root.hidden = true;
      }, 280);
      if (permanent) {
        stopped = true;
        persistBannerDismiss();
        clearTimers();
      }
    }

    function showBanner() {
      if (stopped || window[PAGE_DISMISS_FLAG] || !items.length) return;
      var currentIndex = idx % items.length;
      applyItem(root, items[currentIndex]);
      warmNextWabImage(items, currentIndex + 1);
      warmNextWabImage(items, currentIndex + 2);
      idx += 1;
      root.hidden = false;
      root.classList.remove('is-hiding');
      window.requestAnimationFrame(function () {
        root.classList.add('is-visible');
      });
      hideTimer = window.setTimeout(function () {
        hideBanner(false);
        cycleTimer = window.setTimeout(showBanner, Math.max(0, INTERVAL_MS - VISIBLE_MS));
      }, VISIBLE_MS);
    }

    function scheduleFirstShow() {
      if (stopped || window[PAGE_DISMISS_FLAG] || !items.length) return;
      preloadWabImagesSequential(items, 0, 3).then(function () {
        if (stopped || window[PAGE_DISMISS_FLAG] || !items.length) return;
        cycleTimer = window.setTimeout(showBanner, FIRST_DELAY_MS);
      });
    }

    if (closeBtn) {
      closeBtn.addEventListener('click', function (e) {
        e.preventDefault();
        e.stopPropagation();
        hideBanner(true);
      });
    }

    function handleBannerActivate(e) {
      if (e.target.closest('[data-wab-close]')) return;

      var current = root._wabCurrentItem;
      if (!current) return;

      if (current.type === 'review' && current.reviewData) {
        e.preventDefault();
        e.stopPropagation();
        openReviewModal(current);
        return;
      }

      if (current.type === 'stat' && current.url) {
        e.preventDefault();
        window.location.href = current.url;
      }
    }

    var cardEl = root.querySelector('.wab__card');
    var linkEl = root.querySelector('[data-wab-link]');

    if (cardEl) {
      cardEl.addEventListener('click', handleBannerActivate);
    }

    if (linkEl) {
      linkEl.addEventListener('keydown', function (e) {
        if (e.key === 'Enter' || e.key === ' ') {
          if (e.key === ' ') e.preventDefault();
          handleBannerActivate(e);
        }
      });
    }
    loadItems(root, function onMoreItems(merged) {
      items = merged;
      warmNextWabImage(items, idx);
      warmNextWabImage(items, idx + 1);
    }).then(function (loaded) {
      items = loaded;
      if (!items.length) {
        root.hidden = true;
        return;
      }
      scheduleFirstShow();
    });
  }

  function initAll() {
    document.querySelectorAll('[data-wab-banner]').forEach(initBanner);
  }
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initAll);
  } else {
    initAll();
  }

  document.addEventListener('shopify:section:load', initAll);
})();
